export default "__VITE_ASSET__BPeZVuY$__"